import React, { useState, useEffect } from "react";
import axios from "axios";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import Modal from "react-modal";
import Sidebar from "../componenteExtra/SidebarsocioGET";
import "../App.css";
import { Toaster, toast } from "react-hot-toast";
import SessionManager from '../componenteExtra/SessionManager';

Modal.setAppElement("#root");

const ActividadesCompletadasSocio = () => {
  const [completedActivities, setCompletedActivities] = useState([]);
  const [filteredActivities, setFilteredActivities] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [bitacoraModalIsOpen, setBitacoraModalIsOpen] = useState(false);
  const [bitacoraData, setBitacoraData] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [asignacionesReasignadasData, setAsignacionesReasignadasData] = useState([]);
  const [razonSocialFilter, setRazonSocialFilter] = useState("");

  const token = localStorage.getItem("access_token");

  useEffect(() => {
    // Fetch completed activities
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/get_completed_activities`, {
        headers: { Authorization: `Bearer ${token}` },
    })
        .then(response => {
            setCompletedActivities(response.data);
            setFilteredActivities(response.data);
        })
        .catch(error => console.error('Error fetching data: ', error));

    // Fetch bitacora and reasignaciones data
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/get_bitacora_rechazos_aceptacion_staff`, {
        headers: { Authorization: `Bearer ${token}` },
    })
        .then(response => setBitacoraData(response.data))
        .catch(error => console.error('Error fetching bitacora data: ', error));

    axios.get(`${process.env.REACT_APP_BACKEND_URL}/get_asignaciones_reasignadas`, {
        headers: { Authorization: `Bearer ${token}` },
    })
        .then(response => setAsignacionesReasignadasData(response.data))
        .catch(error => console.error('Error fetching reasignaciones data: ', error));
}, [token]);

useEffect(() => {
    filterActivitiesByDate();
}, [startDate, endDate, razonSocialFilter]);


const filterActivitiesByDate = () => {
  const filtered = completedActivities.filter((activity) => {
    const activityDate = new Date(activity.fecha_aprobacion_trabajo_staff);
    const start = startDate ? new Date(startDate) : null;
    const end = endDate ? new Date(endDate) : null;
    const isWithinDateRange = (!start || activityDate >= start) && (!end || activityDate <= end);

    // Filtrado por razón social si está presente
    const matchesRazonSocial = razonSocialFilter
      ? activity.razon_social.toLowerCase().includes(razonSocialFilter.toLowerCase())
      : true;

    return isWithinDateRange && matchesRazonSocial;
  });
  setFilteredActivities(filtered);
};

  const openModal = (activity) => {
    setSelectedActivity(activity);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedActivity(null);
  };

  const openBitacoraModal = (activity) => {
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/bitacora_rechazos/${activity.id_asignacion_actividad}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        setBitacoraData(response.data);
        setSelectedActivity(activity);
        setBitacoraModalIsOpen(true);
      })
      .catch((error) => {
        console.error("Error fetching bitacora:", error);
        toast.error("Error al obtener la bitácora");
      });
  };

  const closeBitacoraModal = () => {
    setBitacoraModalIsOpen(false);
    setBitacoraData([]);
  };

  const handleDownload = () => {
    // Obtener fecha y hora actual en formato DD-MM-YYYY HH:MM
    const now = new Date();
    const formattedDate = now.toLocaleDateString('es-ES').replace(/\//g, '-');
    const formattedTime = now.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' }).replace(/:/g, '-');
  
    const fileName = `registro_sistema_get_view_${formattedDate}_${formattedTime}.xlsx`;
  
    // Definir el nuevo orden de las columnas, incluyendo las fechas en el orden solicitado
    const columnOrder = [
      'id',
      'codigo_proyecto',
      'nombre_proyecto',
      'razon_social',
      'filial',
      'encargado_auditoria',
      'numero_grupo',
      'jefe_grupo',
      'subrogante',
      'rubro_get',
      'nombre_actividad_get',
      'staff_asignado',
      'correo',
      'horas_get',
      'horas_estandar',
      'Lun',
      'Mar',
      'Mie',
      'Jue',
      'Vie',
      'fecha_ingreso_solicitud',
      'fecha_termino_actividad',
      'fecha_ingreso_documentación',
      'fecha_entrega_información',
      'fecha_asignación_staff',
      'fecha_inicio_trabajo_staff',
      'fecha_aprobacion_trabajo_staff',
      'id_asignacion_actividad',
      'nombre_solicitante',
      'tipo_regulacion',
      'diferencia',
      'comentario_diferencia',
    ];
  
    // Función para reordenar las columnas
    const reorderColumns = (data) => {
      return data.map(item => {
        let reorderedItem = {};
        columnOrder.forEach(col => {
          reorderedItem[col] = item[col];
        });
        return reorderedItem;
      });
    };
  
    const filteredActivitiesForExcel = reorderColumns(filteredActivities.filter((activity) => {
      const activityDate = new Date(activity.fecha_aprobacion_trabajo_staff);
      const start = startDate ? new Date(startDate) : null;
      const end = endDate ? new Date(endDate) : null;
      return (!start || activityDate >= start) && (!end || activityDate <= end);
    }));
  
    // Para las otras hojas, dejamos el orden original
    const filteredBitacoraForExcel = bitacoraData.filter((entry) => {
      const bitacoraDate = new Date(entry.fecha);
      const start = startDate ? new Date(startDate) : null;
      const end = endDate ? new Date(endDate) : null;
      return (!start || bitacoraDate >= start) && (!end || bitacoraDate <= end);
    });
  
    const filteredReassignmentsForExcel = asignacionesReasignadasData.filter((entry) => {
      const reassignDate = new Date(entry.fecha_aprobacion_trabajo_staff);
      const start = startDate ? new Date(startDate) : null;
      const end = endDate ? new Date(endDate) : null;
      return (!start || reassignDate >= start) && (!end || reassignDate <= end);
    });
  
    const sheet1 = XLSX.utils.json_to_sheet(filteredActivitiesForExcel);
    const sheet2 = XLSX.utils.json_to_sheet(filteredBitacoraForExcel);
    const sheet3 = XLSX.utils.json_to_sheet(filteredReassignmentsForExcel);
  
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, sheet1, "Actividades Completadas");
    XLSX.utils.book_append_sheet(workbook, sheet2, "Bitacora Rechazos_Aceptados");
    XLSX.utils.book_append_sheet(workbook, sheet3, "Actividades Reasignadas");
  
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, fileName);
  };

  const totalActividades = filteredActivities.length;


  return (
    <div className="app">
      <SessionManager />
      <Sidebar />
      <div className="main-content">
        <div className="main-panel">
          <h1>Solicitudes finalizadas de GET</h1>
          <h2>Total Actividades: {totalActividades}</h2>
          <div className="filter-container">
            <label>
              Selecciona rango de fecha de aprobación de las actividades:
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </label>
            <label>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </label>
            <label>
  Filtrar por Razón Social:
  <input
    type="text"
    value={razonSocialFilter}
    onChange={(e) => setRazonSocialFilter(e.target.value)}
    placeholder="Ingrese razón social"
  />
</label>
          </div>
          <button onClick={handleDownload} className="download-button">
            Descargar
          </button>
          <div className="activities-table-container">
            <table className="activities-table">
              <thead>
                <tr>
                  <th>Código Proyecto</th>
                  <th>Nombre Proyecto</th>
                  <th>Razón Social</th>
                  <th>Filial</th>
                  <th>Socio de auditoría</th>
                  <th>Solicitante</th>
                  <th>Número de Grupo</th>
                  <th>Jefe de Grupo</th>
                  <th>Subrogante</th>
                  <th>Rubro GET</th>
                  <th>Nombre Actividad GET</th>
                  <th>Staff Asignado</th>
                  <th>Correo Staff</th>                 
                  <th>¿Hay diferencias?</th>
                  <th>Detalle de las diferencias</th>
                  <th>Horas GET</th>
                  <th>Horas Estándar</th>
                  <th>Fecha Inicio Trabajo Staff</th>
                  <th>Fecha Aprobación Trabajo Staff</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {filteredActivities.map((activity, index) => (
                  <tr key={index}>
                    <td>{activity.codigo_proyecto}</td>
                    <td>{activity.nombre_proyecto}</td>
                    <td>{activity.razon_social}</td>
                    <td>{activity.filial}</td>
                    <td>{activity.encargado_auditoria}</td>
                    <td>{activity.nombre_solicitante}</td>
                    <td>{activity.numero_grupo}</td>
                    <td>{activity.jefe_grupo}</td>
                    <td>{activity.subrogante}</td>
                    <td>{activity.rubro_get}</td>
                    <td>{activity.nombre_actividad_get}</td>
                    <td>{activity.staff_asignado}</td>
                    <td>{activity.correo}</td>
                    <td>{activity.diferencia}</td>
                    <td>{activity.comentario_diferencia}</td>
                    <td>{activity.horas_get}</td>
                    <td>{activity.horas_estandar}</td>
                    <td>{activity.fecha_inicio_trabajo_staff}</td>
                    <td>{activity.fecha_aprobacion_trabajo_staff}</td>
                    <td>
                      <button onClick={() => openBitacoraModal(activity)}>
                        Ver Bitácora
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {selectedActivity && (
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          contentLabel="Detalles de la Actividad Completada"
        >
          <h2>Detalles de la Actividad Completada</h2>
          {/* Detalles de la actividad */}
          <button onClick={closeModal}>Cerrar</button>
        </Modal>
      )}
      {bitacoraModalIsOpen && (
        <Modal
          isOpen={bitacoraModalIsOpen}
          onRequestClose={closeBitacoraModal}
          contentLabel="Bitácora de la Actividad"
        >
          <h2>Bitácora de la Actividad</h2>
          {bitacoraData.length > 0 ? (
            <table className="bitacora-table">
              <thead>
                <tr>
                  <th>Tipo</th>
                  <th>Fecha</th>
                  <th>Rol</th>
                  <th>Comentario</th>
                </tr>
              </thead>
              <tbody>
                {bitacoraData.map((entry, index) => (
                  <tr key={index}>
                    <td>{entry.tipo}</td>
                    <td>{entry.fecha}</td>
                    <td>{entry.rol}</td>
                    <td>{entry.comentario}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No hay registros para esta actividad.</p>
          )}
          <button onClick={closeBitacoraModal}>Cerrar</button>
        </Modal>
      )}
      <Toaster />
    </div>
  );
};

export default ActividadesCompletadasSocio;
